// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Exhv","secondary":"Button_secondary__3LPbT"};